<template>
    <div class="customer-service">
        <div class="client-list" v-show="clientListShow">
            <div class="box-wrap">
                <div class="box-header" style="height: 52px">
                    <span>Message</span>
                </div>
                <div class="box-content" style="height: calc(100% - 104px)">
                    <scroll-wrap>
                        <div v-if="message.list.length>0">
                            <div class="message-list-wrap">
                                <div class="item" v-for="(item,index) in message.list" :key="index"
                                     @click="openMessage(item)">
                                    <div class="portrait">
                                        <img :src="item.sellerImage" alt="">
                                    </div>
                                    <div class="message-target">
                                        <div class="person">
                                            {{item.seller}}
                                        </div>
                                        <div class="message">
                                            {{item.message?item.message.content:''}}
                                        </div>
                                    </div>
                                    <div class="right">
                                        <div class="date" v-if="new Date().setHours(0, 0, 0, 0)<(item.message?item.message.senderTime:item.createTime)">
                                            {{new Date(item.message?(item.message.receiveTime ? item.message.receiveTime : item.message.senderTime):item.createTime).$Format('hh:mm')}}
                                        </div>
                                        <div class="date" v-else>
                                            {{new Date(item.message?(item.message.receiveTime ? item.message.receiveTime : item.message.senderTime):item.createTime).$Format('MM-dd')}}
                                        </div>
                                        <div class="message-num" v-if="item.ctxReady>0">
                                            <span>{{item.ctxReady}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else style="width: 100%;height: 100px;color: #adadad;display: flex;align-items: center;justify-content: center;background: #F5F5F5">
                            暂无聊天记录
                        </div>
                    </scroll-wrap>
                </div>
                <div class="box-footer" style="height: 52px">
                    <div class="menu-item" @click="$emit('componentIndex',0)">
                        <i class="iconfont iconshouye"></i>
                        <span>Home</span>
                    </div>
                    <div class="menu-item" @click="$emit('componentIndex',1)">
                        <i class="iconfont icongouwuche"></i>
                        <span>Cart</span>
                    </div>
                    <div class="menu-item active" @click="$emit('componentIndex',2)">
                        <i class="iconfont iconxiaoxi"></i>
                        <span>Service</span>
                    </div>
                    <div class="menu-item" @click="$emit('componentIndex',3)">
                        <i class="iconfont iconwode"></i>
                        <span>My</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-wrap" v-show="!clientListShow">
            <div class="box-wrap">
                <div class="box-header" style="height: 52px">
                    <i class="el-icon-close" @click="clientListShow=true"></i>
                    <span>{{chat.saller.seller}}</span>
                </div>
                <div class="box-content" style="height: calc(100% - 52px - 70px)">
                    <scroll-wrap class="chatWrap">
                        <div v-if="chat.list.length>0">
                            <div class="chat-item"  v-for="(item,index) in chat.list" :key="index">
                                <div class="line" :class="{active:lineActiev(item,chat.list[index-1],index)}">
                                    —— {{new Date(item.senderTime).$Format('yyyy-MM-dd hh:mm',true)}} ——
                                </div>
                                <div class="acceptor" v-if="item.direction===0">
                                    <div class="img">
                                        <img :src="item.receiver.sellerImage" alt="">
                                    </div>
                                    <div class="main">
                                        <div class="username">
                                            {{chat.saller.seller}}
                                        </div>
                                        <div class="message">
                                            {{item.content}}
                                        </div>
                                    </div>
                                </div>
                                <div class="sender" v-else>
                                    <div class="img">
                                        <img :src="item.sender.buyerImage" alt="">
                                    </div>
                                    <div class="main">
                                        <div class="username">
                                            {{item.sender.buyer}}
                                        </div>
                                        <div class="message">
                                            {{item.content}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </scroll-wrap>
                </div>
                <div class="box-footer" style="height: 54px">
                    <div class="input-wrap">
                        <div class="input-box">
                            <textarea class="textareaBuyer" v-model="chat.value" @keydown.enter="sendMessage"></textarea>
                        </div>
                    </div>
                    <div class="input-send">
                        <i class="el-icon-s-promotion" @click="sendMessage"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SockJS from 'sockjs-client'

    export default {
        name: "CustomerService",
        data() {
            return {
                message: {
                    list: []
                },
                chat: {
                    list: [],
                    saller: {},
                    value: ''
                },
                clientListShow: true
            }
        },
        props:{
            product:[Object]
        },
        computed:{

        },
        created() {
            this.initClient().then(()=>{
                if(this.product){
                    this.openMessage(this.product.user)
                }
            })
        },
        mounted() {

        },
        beforeDestroy() {
            this.$emit('cleanProduct')
            this.client.close()
        },
        methods: {
            lineActiev(item,item_1,index){
                if(index===0) return true
                return item.senderTime - item_1.senderTime > 3600000;

            },
            initClient() {
                return new Promise(resolve => {
                    this.client = new SockJS("/ws-chat-js?type=2");
                    this.client.onopen = () => {
                        resolve()
                    }
                    this.handlerMessage()
                })
            },
            openMessage(item) {
                this.clientListShow = false;
                if(item){
                    this.chat.saller = item;
                }
                let message = {
                    handler: 'CurrentSession',
                    target: {
                        UserId: this.chat.saller.id,
                        VersionId: 1,
                        MessageType: 'CUSTOMER'
                    }
                }
                this.client.send(JSON.stringify(message));
                this.handlerMessage().then(()=>{
                    document.querySelector(".chatWrap").children[0].scrollTop =
                        document.querySelector(".chatWrap").children[0].scrollHeight -
                        document.querySelector(".chatWrap").children[0].clientHeight
                })
            },
            handlerMessage() {
                return new Promise((resolve)=>{
                    this.client.onmessage = (message) => {
                        let $message = JSON.parse(message.data);
                        switch ($message.operator) {
                            case 'UserList':
                                console.log($message.items)
                                this.message.list = $message.items;
                                resolve()
                                break;
                            case 'InitMessage':
                                this.chat.list = $message.items
                                this.$nextTick(()=>{
                                    document.querySelector(".chatWrap").children[0].scrollTop =
                                        document.querySelector(".chatWrap").children[0].scrollHeight -
                                        document.querySelector(".chatWrap").children[0].clientHeight
                                })
                                resolve()
                                break;
                            case 'FutureMessage':
                                this.chat.list = this.chat.list.concat($message.items);
                                this.$nextTick(()=>{
                                    document.querySelector(".chatWrap").children[0].scrollTop =
                                        document.querySelector(".chatWrap").children[0].scrollHeight -
                                        document.querySelector(".chatWrap").children[0].clientHeight
                                })

                                resolve()
                                break;
                        }
                    }
                })

            },
            closeMessage() {
                this.client.onclose = function () {
                    console.log('close', arguments);
                }
            },
            sendMessage(){
                if(this.chat.value.trim()===''){
                    document.querySelector('.textareaBuyer').focus()
                    return false;
                }
                this.axios.post("/student/customer/message/sender",{
                    type:2,
                    receiverId:this.chat.saller.id,
                    messageType:'CUSTOMER',
                    content:this.chat.value
                }).then(res=>{
                    if(res.succeed){
                        // this.openMessage();
                        this.chat.value = "";
                        this.handlerMessage().then(()=>{
                            document.querySelector(".chatWrap").children[0].scrollTop =
                                document.querySelector(".chatWrap").children[0].scrollHeight -
                                document.querySelector(".chatWrap").children[0].clientHeight
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.customer-service {
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 0 0 20px 20px;

        div.client-list {
            width: 100%;
            height: 100%;

            > div.box-wrap {
                width: 100%;
                height: 100%;

                div.box-header {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    border-bottom: 1px solid #F5F5F5;

                    > i {
                        position: absolute;
                        top: 50%;
                        left: 0;
                        font-weight: bolder;
                        transform: translateY(-50%);
                        font-size: 18px;
                        padding: 10px;
                        cursor: pointer;

                        &:hover {
                            opacity: 0.8;
                        }
                    }

                    > span {
                        font-size: 18px;
                        color: #000000;
                        font-weight: bolder;
                    }
                }

                div.box-content {
                    position: relative;

                    .message-list-wrap {
                        > .item {
                            display: flex;
                            width: 100%;
                            height: 75px;
                            padding: 0 12px;
                            box-sizing: border-box;
                            align-items: center;
                            border-bottom: 1px solid #F5F5F5;

                            &:hover {
                                background: #F5F5F5;
                                cursor: pointer;
                            }

                            div.portrait {
                                width: 52px;
                                height: 52px;
                                flex-shrink: 0;
                                margin-right: 12px;

                                > img {
                                    border-radius: 50%;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            div.message-target {
                                flex-shrink: 1;
                                overflow: hidden;
                                box-sizing: border-box;
                                flex-grow: 1;

                                div {
                                    font-size: 14px;
                                    line-height: 24px;

                                    &.person {
                                        font-size: 16px;
                                    }

                                    &.message {
                                        letter-spacing: 1px;
                                        text-overflow: ellipsis;
                                        line-height: 32px;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 1;
                                        overflow: hidden;
                                        font-size: 12px;
                                        color: #9F9F9F;
                                    }
                                }
                            }

                            div.right {
                                margin-left: 12px;
                                width: 52px;
                                height: 56px;
                                flex-shrink: 0;

                                div {
                                    line-height: 24px;
                                    text-align: right;
                                    display: flex;
                                    justify-content: flex-end;

                                    &.date {
                                        color: #9F9F9F;
                                        font-size: 14px;
                                    }

                                    &.message-num {
                                        span {
                                            width: 18px;
                                            height: 18px;
                                            text-align: center;
                                            line-height: 18px;
                                            color: #FFFFFF;
                                            font-size: 12px;
                                            border-radius: 50%;
                                            background: #ff8700;
                                            margin: 6px;
                                            box-sizing: border-box;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                div.box-footer {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    border-top: 1px solid #d9d9d9;
                    box-sizing: border-box;

                    > .menu-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        padding: 0 12px;

                        > i {
                            font-size: 24px;
                            margin-bottom: 4px;
                        }

                        > span {
                            font-size: 12px;
                        }

                        &.active {
                            color: #089bab;
                        }
                    }
                }
            }
        }

        div.chat-wrap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #ffffff;
            border-radius: 0 0 20px 20px;
            overflow: hidden;

            > div.box-wrap {
                width: 100%;
                height: 100%;

                div.box-header {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    > i {
                        position: absolute;
                        top: 50%;
                        left: 0;
                        font-weight: bolder;
                        transform: translateY(-50%);
                        font-size: 18px;
                        padding: 10px;
                        cursor: pointer;

                        &:hover {
                            opacity: 0.8;
                        }
                    }

                    > span {
                        font-size: 18px;
                        color: #000000;
                        font-weight: bolder;
                    }
                }

                div.box-content {
                    position: relative;
                    background: #F2F2F2;

                    .chat-item {
                        padding: 12px;

                        div.line {
                            width: 100%;
                            text-align: center;
                            font-size: 12px;
                            margin: 10px 0;
                            color: #9e9e9e;
                            display: none;
                            &.active {
                                display: block;
                            }
                        }

                        div.acceptor {
                            display: flex;

                            > .img {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                margin-right: 10px;
                                overflow: hidden;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            .main {
                                width: 76%;
                                display: flex;
                                flex-direction: column;
                                word-break: break-all;

                                > .username {
                                    font-size: 14px;
                                    margin-bottom: 6px;
                                    color: #4f57af;
                                    font-weight: 900;
                                }

                                > .message {
                                    background: #ffffff;
                                    padding: 12px;
                                    border-radius: 10px;
                                    font-size: 14px;

                                }
                            }
                        }

                        div.sender {
                            display: flex;
                            flex-direction: row-reverse;

                            > .img {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                margin-left: 10px;
                                overflow: hidden;

                                > img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }

                            .main {
                                width: 76%;
                                display: flex;
                                flex-direction: column;
                                word-break: break-all;

                                > .username {
                                    font-size: 14px;
                                    margin-bottom: 6px;
                                    text-align: right;
                                    color: #ff65a5;
                                    font-weight: 900;
                                }

                                > .message {
                                    background: #CDEBED;
                                    padding: 12px;
                                    border-radius: 10px;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                }

                div.box-footer {
                    overflow: hidden;
                    height: 36px;
                    margin: 8px;
                    box-sizing: border-box;
                    position: relative;
                    display: flex;

                    div.input-wrap {
                        width: calc(100% - 40px);
                        overflow: hidden;
                        border-radius: 6px;
                        div.input-box {
                            width: calc(100% + 17px);
                            margin-right: - 17px;
                            height: 100%;

                            textarea {
                                height: 100%;
                                width: 100%;
                                padding: 6px;
                                outline: none;
                                resize: none;
                                border: none;
                                box-sizing: border-box;
                                overflow-y: scroll !important;
                                background: #F2F2F2;
                            }
                        }
                    }
                    div.input-send {
                        width: 40px;
                        > i {
                            cursor: pointer;
                            position: absolute;
                            color: #ff8700;
                            right: 0;
                            top: 50%;
                            padding: 6px;
                            transform: translateY(-50%);
                            font-size: 26px;
                            transition: color 0.3s linear;
                            &:hover {
                                transition: color 0.3s linear;
                                color: #089bab;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
